import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { DgTimerService } from '../dg_components/dg-timer/dg-timer.service';
import { Response } from '../models/response.model';
import { SelectedPost } from '../models/switchPost.model';

import { User } from './../dg_core/header/header.component';
import { AppInitService } from './app-init.service';
import { EncryptionService } from './encryption.service';
import { SessionCheckerService } from './session-checker.service';
import { PrivilegeGuard } from '../guards/privilege.guard';
import { OAuthService } from 'angular-oauth2-oidc';
import { stringify,parse } from 'flatted';
import {
  AuthType,
  CaptchaType,
  PayloadType,
} from '../constants/digigov.constants';
import { getRoleBasedRoute } from 'src/app/routes/role-based-route';

import { MainService } from '../dg_core/main/main.service';
// declare var require :any;
// const AcrossTabs = require("across-tabs");
//ADDED THIS FOR MULTI TAB SESSION LOGOUT
export const CrossTabSessionSubject = new BehaviorSubject(false);

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  private _loggedInUser: User;
  private _loggedInUserSubject: BehaviorSubject<User>;
  private _csrfToken: string;
  broadCastChannel1 = new BroadcastChannel("LOGOUT");
  //Post Id
  private _loggedInUserPost: SelectedPost;
  private _loggedInUserPostSubject = new BehaviorSubject<SelectedPost>(null);
  public loggedInUserPost$ = this._loggedInUserPostSubject.asObservable();
  public loggedInUser$;
  parent:any;

  broadCastChannelLogout : BroadcastChannel = new BroadcastChannel("DGGOV_LOGOUT");
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private appInitService: AppInitService,
    private encryptionService: EncryptionService,
    private dialog: MatDialog,
    private mainService:MainService,
    //Session Checker
    private sessionCheckerService: SessionCheckerService,
    private dgTimerService: DgTimerService,
    //PRIVGUARD
    private privGuardService: PrivilegeGuard,
    //OIDC
    private oauthService: OAuthService

    
  ) {
    this.csrfToken = localStorage.getItem('X-CSRF-TOKEN');

    this.currentUserSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem('userAuthToken'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this._loggedInUserSubject = new BehaviorSubject(null);
    this.loggedInUser$=this._loggedInUserSubject.asObservable();
    this.appInitService.appConfigObs.subscribe((appConfig) => {
      if (
        appConfig?.showSessionChecker &&
        appConfig?.authType === AuthType.COOKIE
      ) {
        window.addEventListener('storage', (event) => {
          if (event.key == 'param_2' && event.newValue !== 'N') {
            this.logout(event.newValue === 'E' ? true : false);
          }
        });
      }
    });
    //FOR MULTI TAB LOGOUT
    CrossTabSessionSubject.asObservable().subscribe((logout) => {
      if (logout) {
        this.logout();
      }
    });
  }

  ngOnInit(): void {
    // var config = {
    //   onHandshakeCallback: function () { },
    //   onPollingCallback: function () { }
    //   }
    //   this.parent = new AcrossTabs.Parent(config);
  }

  public get currentUserValue(): any {
    switch (this.appInitService.appConfig?.authType) {
      case AuthType.JWT:
        let localUserValue = localStorage?.getItem('userAuthToken');
        this.currentUserSubject.next(JSON.parse(localUserValue));
        return this.currentUserSubject.value;
      case AuthType.COOKIE:
        return localStorage.getItem('userAuthToken');
      case AuthType.OATUH2:
        return this.oauthService.getAccessToken();
      case AuthType.PRE_AUTH:
        return true;
      default:
        return false;
    }
  }

  get loggedInUser() {
    return this._loggedInUser;
  }

  get loggedInUserPost(): SelectedPost {
    return this._loggedInUserPost;
  }

  set loggedInUser(user: User) {
    this._loggedInUser = user;
    this.loggedInUserSubject.next(user);
  }

  get justLogin() {
    if (
      localStorage.getItem('justLogin') &&
      localStorage.getItem('justLogin') != 'undefined'
    ) {
      return JSON.parse(localStorage.getItem('justLogin'));
    }
    return false;
  }

  set justLogin(value) {
    localStorage.setItem('justLogin', JSON.stringify(value));
  }

  set loggedInUserPost(postDetails: SelectedPost) {
    this._loggedInUserPost = postDetails;
    this._loggedInUserPostSubject.next(postDetails);
  }

  get loggedInUserSubject(): BehaviorSubject<User> {
    return this._loggedInUserSubject;
  }

  login(username, password, captcha, captchaId) {
    let sessionObs = of(null);
    if (this.appInitService.appConfig.payload === PayloadType.FUTURISTIC) {
      sessionObs = this.appInitService.getSessionCheckerId();
    }
    return sessionObs.pipe(
      switchMap((sessionId) => {
        let salt = null;
        const id = sessionId ?? this.encryptionService.generateSalt();
        if (this.appInitService?.appConfig?.encryptPassword) {
          let encryptedData = this.encryptionService.encrypt(password);

          //SECURITY ISSUE SOLUTION
          password = this.encryptionService.encrypt(password, id).cipherText;
          //password = encryptedData?.cipherText;
          salt = encryptedData?.salt;
          password = encodeURIComponent(password);
        }
        let body = new HttpParams()
          .set('username', username)
          .set('password', password)
          .set('temp_key', salt);

        if (this.appInitService?.appConfig?.captchaType === CaptchaType.TEXT) {
          body = body.set('txt_Captcha', captcha).set('id', captchaId);
        } else if (
          this.appInitService?.appConfig?.captchaType ===
          CaptchaType.RECAPTCHA_V3
        ) {
          body = body.set('g-recaptcha-response', captchaId);
        }
        return this.getLoginRequest(body, id);
      })
    );
  }

  getLoginRequest(body, id): Observable<any> {
    let header = new HttpHeaders().append('_fc', id);
    return this.http
      .post<any>('/login', body, {
        headers: header,
        observe: 'response',
      })
      .pipe(
        map(
          (loginResponsetemp) => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            if (loginResponsetemp?.headers?.get('X-CSRF-TOKEN')) {
              this.csrfToken = loginResponsetemp?.headers?.get('X-CSRF-TOKEN');
              localStorage.setItem('X-CSRF-TOKEN', this.csrfToken);
            }
            if (
              this.appInitService?.appConfig?.showSessionChecker &&
              this.appInitService?.appConfig?.authType === AuthType.COOKIE
            ) {
              localStorage.setItem('param_2', 'N');
            }
            let loginResponse = loginResponsetemp['body'];
            if (
              loginResponse &&
              loginResponse.data &&
              loginResponse.data.token
            ) {
              let userLogin;
              if (this.appInitService.appConfig?.authType === AuthType.COOKIE) {
                userLogin = {
                  authenticated: true,
                };
                if (this.appInitService?.appConfig?.showSessionChecker) {
                  this.sessionCheckerService.startCountDown();
                }
              } else {
                userLogin = loginResponse.data;
              }
              localStorage.setItem('userAuthToken', JSON.stringify(userLogin));

              this.currentUserSubject.next(loginResponse.data);
              this.justLogin = true;
              return loginResponse.data;
            } else if (loginResponse.message) {
              this.toastr.error(loginResponse.message);
            }
          },
          (err) => {
            this.toastr.error(err);
          }
        )
      );
  }
  getUserDetails() {
    return this.http.get(`/admin/my-profile`).pipe(
      map((response: Response<User>) => response.data),
      catchError((error) => {
        throw error;
      })
    );
  }
  getLoggedInUserDetails(isRoleBasedRoute = false): Observable<User> {
    return this.http.get('/admin/user-login-dtls').pipe(
      map((res: Response<User>) => res.data),
      tap((userData) => {
        this.loggedInUser = userData;
        if (isRoleBasedRoute) {
          this.appInitService.isDoneLoadingSubject$.next(false);
          this.appInitService.isAfterLoginDone = false;
          let getRoleBasedRouteStr = '';
          if (this.appInitService.appConfig.hasRoleBasedRouting) {
            getRoleBasedRouteStr = getRoleBasedRoute(userData);
          }
          this.router.navigateByUrl(
            getRoleBasedRouteStr
              ? getRoleBasedRouteStr
              : this.appInitService.appConfig.afterLoginLandingUrl
          );
          this.appInitService.isDoneLoadingSubject$.next(true);
          this.appInitService.isAfterLoginDone = true;
        }
      }),
      catchError(() => {
        this.router.navigateByUrl(
          this.appInitService.appConfig.afterLoginLandingUrl
        );
        return throwError('ERROR');
      })
    );
  }
  logout(isSessionExpired = false): void {
    this.dgTimerService.terminateAllTimer();
    if (
      this.appInitService?.appConfig?.showSessionChecker &&
      this.appInitService?.appConfig?.authType == AuthType.COOKIE
    ) {
      this.sessionCheckerService.stopCountDown(isSessionExpired ? -1 : 0);
      localStorage.removeItem('param_1');
      localStorage.setItem('param_2', isSessionExpired ? 'E' : 'Y');
    }
    this.loggedInUser = null;
    //remove user from local storage and set current user to null
    localStorage.removeItem('userAuthToken');
    localStorage.removeItem('micro_services');
    localStorage.removeItem('contextPath');
    localStorage.removeItem('X-CSRF-TOKEN');
    localStorage.removeItem('justLogin');
    this.currentUserSubject.next(null);

    localStorage.setItem("logout","logout");
    //RESETING GUARDS URLS
    this.privGuardService.resetPrivRoutes();
    // this._broadCastChannelPostMessage_();
    
   
    
    // this.parent.broadCastAll("LOGOUT");

    //CLOSE POPUPS
    this.dialog.closeAll();
    if (this.appInitService.appConfig.authType === AuthType.PRE_AUTH) {
      window.location.href = this.appInitService?.appConfig?.preAuthLogoutUrl;
    } else if (this.appInitService?.appConfig?.authType !== AuthType.OATUH2) {
      void this.router.navigateByUrl(
        this.appInitService?.appConfig?.authenticationLogoutUrl
      );
    }
    if (
      this.appInitService?.appConfig?.authType == AuthType.COOKIE ||
      this.appInitService.appConfig.authType === AuthType.OATUH2
    ) {
      const headers = { 'content-type': 'application/json' };
      const body = new HttpParams();
      const params = new HttpParams().append('logoutType', 'system');
      this.http
        .post('/logout', body, {
          headers: headers,
          params:
            localStorage.getItem('param_2')?.toString() === 'E' ? params : null,
        })
        .subscribe(
          () => {
            if (this.appInitService.appConfig.authType === AuthType.OATUH2) {
              this.appInitService.logOutWithOIDC();
              this.broadCastChannelLogout.postMessage(
                {
                  dgGovLogout: true
                }
              );
              localStorage.setItem("logout","logout");
            }
          },
          (error) => {
            console.error('error', error);
          }
        );
    }
  }

  //Check Prerequisite
  checkPrerequisite(postJson) {
    return this.http
      .post(`/security/forgot-password/check-prerequisite`, postJson)
      .pipe(
        map((response: any) => response?.data),
        catchError((err) => {
          console.error(err);
          throw err;
        })
      );
  }
  //Micro-service code
  getMicroServiceCode() {
    return this.http
      .get(`/admin/application/microservicecode-appcode-mpg`)
      .pipe(
        map((response: any) => response?.data),
        catchError((err) => {
          console.error(err);
          throw err;
        })
      );
  }
  getContextPath() {
    return this.http.get(`/admin/microservice/code-contextpath-mpg`).pipe(
      map((response: any) => response?.data),
      catchError((err) => {
        console.error(err);
        throw err;
      })
    );
  }
  //get User status

  getUserStatus(userName) {
    return this.http
      .post(`/admin/user-status`, {
        uniqueId: userName,
      })
      .pipe(
        map((response: any) => response?.data),
        catchError((err) => {
          console.error(err);
          throw err;
        })
      );
  }

  //Data-Privacy
  getTermsOfUsage() {
    return this.http.get(`/admin/data-privacy`).pipe(
      map((response: any) => response?.data),
      catchError((err) => {
        console.error(err);
        throw err;
      })
    );
  }
  checkDataPrivacyFlag(postJson) {
    return this.http.post(`/admin/data-privacy`, postJson).pipe(
      map((response: any) => response?.data),
      catchError((err) => {
        console.error(err);
        throw err;
      })
    );
  }
  updateDataPrivacy(postJson) {
    return this.http.put(`/admin/data-privacy`, postJson).pipe(
      map((response: any) => response?.data),
      catchError((err) => {
        console.error(err);
        throw err;
      })
    );
  }
  getTokenFromCookie(): Observable<string> {
    return this.http
      .get('/security/access-token')
      .pipe(map((res: Response<{ token: string }>) => res?.data?.token));
  }
  coreLoginInitiazationAfterSSO(): Observable<any> {
    return this.http
      .post(
        '/security/initialize-login-dtls',
        { 'unique-id': (this.oauthService as any).getSessionState() },
        {
          observe: 'response',
        }
      )
      .pipe(
        tap((loginRes) => {
          if (loginRes?.headers?.get('X-CSRF-TOKEN')) {
            this.csrfToken = loginRes?.headers?.get('X-CSRF-TOKEN');
            localStorage.setItem('X-CSRF-TOKEN', this.csrfToken);
          }
        })
      );
  }

  //  _broadCastChannelPostMessage_(){
  //     this.broadCastChannel1.postMessage(
  //       {
  //         logout: "logout",
  //       }
  //     );
  // }
  /**
   * Getter csrfToekn
   * @return {string}
   */
  public get csrfToken(): string {
    return this._csrfToken;
  }

  /**
   * Setter csrfToekn
   * @param {string} value
   */
  public set csrfToken(value: string) {
    this._csrfToken = value;
  }
}
